import { render, staticRenderFns } from "./DowntimeSingleView.vue?vue&type=template&id=2f0c0472&scoped=true&"
import script from "./DowntimeSingleView.vue?vue&type=script&lang=js&"
export * from "./DowntimeSingleView.vue?vue&type=script&lang=js&"
import style0 from "./DowntimeSingleView.vue?vue&type=style&index=0&id=2f0c0472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c0472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0c0472')) {
      api.createRecord('2f0c0472', component.options)
    } else {
      api.reload('2f0c0472', component.options)
    }
    module.hot.accept("./DowntimeSingleView.vue?vue&type=template&id=2f0c0472&scoped=true&", function () {
      api.rerender('2f0c0472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/downtime/DowntimeSingleView.vue"
export default component.exports